import {
  GoalsInReviewMode_FeedbackCycleFragment,
  ObjectiveInReviewMode,
} from '../../../__generated__/graphql';

export type GoalsInReviewMode = 'NONE' | 'SIDEBAR' | 'INLINE_AS_QUESTIONS';

export const resolveGoalsInReviewMode = (
  input: GoalsInReviewMode_FeedbackCycleFragment,
): GoalsInReviewMode => {
  const { flair__Manage_Goals__c: manageGoals, objectiveTimePeriod } = input;
  const frameworkMode =
    objectiveTimePeriod?.framework?.flair__Objective_In_Review_Mode__c;

  if (frameworkMode && frameworkMode !== ObjectiveInReviewMode.Unknown) {
    switch (frameworkMode) {
      case ObjectiveInReviewMode.None:
        return 'NONE';
      case ObjectiveInReviewMode.Sidebar:
        return 'SIDEBAR';
      case ObjectiveInReviewMode.InlineAsQuestions:
        return 'INLINE_AS_QUESTIONS';
    }
  }

  // Fallback to legacy boolean
  return manageGoals ? 'SIDEBAR' : 'NONE';
};

export const useGoalsInReviewMode = (
  input: GoalsInReviewMode_FeedbackCycleFragment | undefined,
): GoalsInReviewMode => {
  if (!input) {
    return 'NONE';
  }
  return resolveGoalsInReviewMode(input);
};
